import {
    createContext,
    useContext,
    ReactElement,
    PropsWithChildren
} from "react";

import { ITrelloClient, TrelloClient } from "../../client";

export const TrelloClientContext = createContext<ITrelloClient>(
    new TrelloClient()
);

export type TrelloClientProviderProps = {
    readonly client: ITrelloClient;
};

export const TrelloClientProvider = ({
    client,
    children
}: PropsWithChildren<TrelloClientProviderProps>): ReactElement => {
    return (
        <TrelloClientContext.Provider value={client}>
            {children}
        </TrelloClientContext.Provider>
    );
};

export function useTrelloClient() {
    return useContext(TrelloClientContext);
}
